// extracted by mini-css-extract-plugin
module.exports = {"title":"BundleFeatures_title__7AwMu","list":"BundleFeatures_list__3wQFa","listItem":"BundleFeatures_listItem__3-XAa","listItemContent":"BundleFeatures_listItemContent___dWD2"};